<template>
  <div class="kp-modular-check kp-modular-check-without-icon">
    <input type="checkbox" @change="stepChangeDescriptionVisibity({ event: $event, id: step.id })" v-bind:checked="step.description_visibility"><span></span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    step: 'stepActive',
  }),
  methods: mapActions([
    'stepChangeDescriptionVisibity',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** DescriptionCheckbox.vue?1ed4b69d
 **/